import React from "react";
import Container from "./ui/Container";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <Container className="py-10 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
        
        {/* Left side */}
        <div className="text-sm text-gray-600">
          <p className="font-semibold">Pollachi Wealth Care</p>
          <p className="mt-1">© {new Date().getFullYear()} All rights reserved.</p>
          <p className="mt-1 text-gray-500">Terms & Conditions apply</p>
        </div>

        {/* Social icons */}
        <div className="flex gap-4 text-gray-500">
          <a href="https://www.facebook.com/kalimuthu.loganathan.7" target="_blank" rel="noopener noreferrer"
             className="hover:text-blue-600 transition-colors">
            <FaFacebookF className="w-6 h-6" />
          </a>
          <a href="https://www.instagram.com/kalimuthuloganathan" target="_blank" rel="noopener noreferrer"
             className="hover:text-pink-500 transition-colors">
            <FaInstagram className="w-6 h-6" />
          </a>
          <a href="https://wa.me/9488114887" target="_blank" rel="noopener noreferrer"
             className="hover:text-green-500 transition-colors">
            <FaWhatsapp className="w-6 h-6" />
          </a>
        </div>

        {/* Right side */}
        <div>
          <h4 className="font-semibold mb-2">Quick links</h4>
          <ul className="space-y-1 text-gray-600">
            <li><a href="/loans" className="hover:text-blue-600">Loans</a></li>
            <li><a href="/insurance" className="hover:text-blue-600">Insurance</a></li>
            <li><a href="/thawa" className="hover:text-blue-600">Thawa FSPL</a></li>
          </ul>
        </div>
      </Container>
    </footer>
  );
}
